var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.map)?_c('SimpleTable',{attrs:{"localize-headers":"","columns":_vm.humusClassColumns,"data":_vm.humusClassData},scopedSlots:_vm._u([{key:"range",fn:function(ref){
var value = ref.value;
return [_c('IxRes',[_vm._v(_vm._s(("frs.mapManagement.details.soilMaps.humusClasses_range_" + value)))])]}},{key:"area",fn:function(ref){
var value = ref.value;
return [_vm._v("\n    "+_vm._s(_vm.$i18n.format(value, 'area'))+" ("+_vm._s(_vm.$i18n.format(value / _vm.totalArea, 'percent'))+")\n  ")]}}],null,false,1080355869)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }